var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "container" }, [
    _c("div", { staticClass: "footer flex-space-between" }, [
      _c(
        "div",
        { staticClass: "flex-align-center" },
        [
          _c("CommonPing"),
          _c("p", { staticClass: "footer-copyright flex-start" }, [
            _vm._v(" " + _vm._s(_vm.$t("layout.footer.copyright")) + " "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer-link flex-center" },
        _vm._l(_vm.COMMUNITY, function (item) {
          return _c(
            "div",
            { key: item.name, staticClass: "footer-link-item" },
            [
              _c(
                "a",
                {
                  staticClass: "footer-link-item-a",
                  attrs: {
                    href: item.link,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_c("i", { class: `icon icon-social-footer-${item.icon}` })]
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }